export default "__VITE_ASSET__iUmIJYLN__"